// @ts-nocheck
import * as React from "react";

// 공용 페이지네이션 컨트롤: 처음/이전/페이지번호 윈도우/다음/마지막.
// totalPages가 많아도 윈도우(현재 ±2)만 보여 UI가 좁아지지 않는다.
// region-management, admins 등 페이지네이션이 필요한 화면이 공통으로 사용.
//
// Props:
//   page        — 현재 페이지(1-indexed)
//   totalPages  — 전체 페이지 수
//   onPage      — (newPage) => void
export function Pager({ page, totalPages, onPage }) {
  if (totalPages <= 1) return null;
  const win = 2;
  const from = Math.max(1, page - win);
  const to   = Math.min(totalPages, page + win);
  const nums = [];
  for (let i = from; i <= to; i++) nums.push(i);
  const Btn = ({ label, target, disabled, active }) => (
    <button
      type="button"
      onClick={() => onPage(target)}
      disabled={disabled}
      style={{
        minWidth: 32, height: 28, padding: '0 8px',
        border: '1px solid var(--border-soft)',
        background: active ? 'var(--orange-500)' : 'var(--surface)',
        color:      active ? '#fff'              : 'var(--ink-2)',
        borderRadius: 6, fontSize: 12, fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
      }}>
      {label}
    </button>
  );
  return (
    <div style={{ marginTop: 14, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
      <Btn label="«" target={1}          disabled={page === 1}/>
      <Btn label="‹" target={page - 1}   disabled={page === 1}/>
      {from > 1 && <span className="muted" style={{ padding: '0 4px' }}>…</span>}
      {nums.map(n => <Btn key={n} label={n} target={n} active={n === page}/>)}
      {to < totalPages && <span className="muted" style={{ padding: '0 4px' }}>…</span>}
      <Btn label="›" target={page + 1}     disabled={page === totalPages}/>
      <Btn label="»" target={totalPages}   disabled={page === totalPages}/>
    </div>
  );
}
